import { AsyncPipe } from '@angular/common';
import { Component, viewChild } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MenuComponent } from '../../components/menu/menu.component';
import { NavigationBaseComponent } from '../navigation-base/navigation-base.component';
import { NavigationToolbarComponent } from '../navigation-toolbar/navigation-toolbar.component';

@Component({
  selector: 'lfw-sidebar-navigation',
  templateUrl: './sidebar-navigation.component.html',
  styleUrls: ['./sidebar-navigation.component.scss'],
  imports: [
    MatIconButton,
    MatIcon,
    RouterLinkActive,
    RouterLink,
    MatSidenavContainer,
    MatSidenav,
    MatNavList,
    MatListItem,
    MenuComponent,
    MatSidenavContent,
    AsyncPipe,
    NavigationToolbarComponent
  ]
})
export class SidebarNavigationComponent extends NavigationBaseComponent {
  protected readonly sidenav = viewChild.required<MatSidenav>('sidenav');

  closeBackdrop(force: boolean): void {
    if (this.hasBackdrop || force) {
      this.sidenav().close();
    }
  }

  get hasBackdrop(): boolean {
    return this.settingsService.settings.viewMode.sideBarCollapse;
  }
}
